import compact from "lodash/compact";
import flatMap from "lodash/flatMap";
import sortBy from "lodash/sortBy";
import uniq from "lodash/uniq";

/**
 * Extract all tags from platformAnalyticsTagList attribute
 * @param projects
 * @returns array
 */
export const getProjectTags = (projects) => {
  if (!projects) return;

  let tags = flatMap(projects, "platformAnalyticsTagList");
  tags = compact(tags);

  if (!tags) return;

  const uniqTags = uniq(tags);

  return sortBy(uniqTags);
};
